module.exports = __webpack_public_path__ + "sara-0576e947e95311e2cbec19b437ae8b56.webp";